import styled from 'styled-components'

import { headerHeight } from '../styles'

export const FixedFix = styled.div`
  height: ${headerHeight};
`
